import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as MenuByUserActions from './menu-by-user.actions';
import { MenuByUserApiService } from './menu-by-user.api.service';
import { ArkikAlertService } from 'src/app/shared/components/arkik-alert/arkik-alert.service';
import { TranslationService } from 'src/app/core/services/common/translation.service';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectMenuByUserData } from './menu-by-user.selectors';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class MenuByUserEffects {
  constructor(
    private actions$: Actions,
    private api: MenuByUserApiService,
    private _alert: ArkikAlertService,
    private _t: TranslationService,
    private store: Store,
  ) {}

  loadMenuByUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MenuByUserActions.loadMenuByUser),
      withLatestFrom(this.store.select(selectMenuByUserData)),
      switchMap(([action, data]) => {
        if (data) {
          return of(MenuByUserActions.loadMenuByUserSuccess({ response: data }));
        }
        return this.api.getMenusByUser(action.request).pipe(
          map((response) => MenuByUserActions.loadMenuByUserSuccess({ response })),
          catchError((e) => {
            this._alert.error(e?.error?.message || this._t.pt('views.globals.an-error-occurred'));
            return of(MenuByUserActions.loadMenuByUserFailure({ error: e?.error?.message || 'Error' }));
          }),
        );
      }),
    ),
  );

  refreshMenuByUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MenuByUserActions.refreshMenuByUser),
      switchMap((action) =>
        this.api.getMenusByUser(action.request).pipe(
          map((response) => MenuByUserActions.loadMenuByUserSuccess({ response })),
          catchError((e) => {
            this._alert.error(e?.error?.message || this._t.pt('views.globals.an-error-occurred'));
            return of(MenuByUserActions.loadMenuByUserFailure({ error: e?.error?.message || 'Error' }));
          }),
        ),
      ),
    ),
  );
}
